module.exports = __webpack_public_path__ + "img/09-shunya-logo.78c60194.png";